import Image from "next/image"

type GeneratorHeaderProps = {
  imageLink?: string
  subject: string
  subcategory?: string
  description?: string
}

export function BaseGeneratorHeader({
  imageLink,
  subject,
  subcategory,
  description,
}: GeneratorHeaderProps) {
  return (
    <div className="grid gap-3">
      {imageLink && (
        <div className="relative mx-auto size-14 justify-center sm:size-24">
          <Image
            src={imageLink}
            alt={`${subject} avatar`}
            fill
            style={{ objectFit: "cover", objectPosition: "center" }}
            sizes="128px"
            className="overflow-hidden rounded-full"
          />
        </div>
      )}
      <div>
        {subcategory && (
          <span className="flex justify-center text-sm text-muted-foreground sm:text-base">
            {subcategory}
          </span>
        )}
        <h3 className="text-center text-2xl font-bold leading-5 tracking-tighter sm:text-3xl">
          {subject}
        </h3>
      </div>
      {description && (
        <p className="text-center text-sm text-muted-foreground">
          {description}
        </p>
      )}
    </div>
  )
}
